import { useEffect } from 'react'

const FACEBOOK_PIXEL_ID = '940043908449013'

export function useFacebookPixel() {
  useEffect(() => {
    const w = window as any

    // Prevent double-initialization
    if (w.fbq) return

    // Official Facebook Pixel base code
    const n: any = (w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })

    if (!w._fbq) w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    // Load the fbevents.js script
    const t = document.createElement('script')
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const s = document.getElementsByTagName('script')[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      document.head.appendChild(t)
    }

    // Only init — pixel auto-tracks PageView
    w.fbq('init', FACEBOOK_PIXEL_ID)
  }, [])
}
